.container {
    min-height: 100px;
}

.title {
    text-align: center;
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 600;
    letter-spacing: 2px;
    color: #b19386;
    margin-bottom: 20px;
}

.text {
    text-align: center;
    margin-bottom: 70px;
    color: #4a4a4a;
}

.projectContainer {
    display: flex;
    justify-content: space-around;
}

.projectImage {
    margin-top: 30px;
    width: 230px;
    height: 230px;
    object-fit: cover;
    border-radius: 230px;
    z-index: 2;
    transform: scale(1);
    transition: 0.4s ease-in-out;
}

.projectCard {
    padding: 0 75px 30px;
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    color: inherit;
    text-decoration: none;
}

.projectCard:before {
    content: '';
    position: absolute;
    transition: 0.5s all ease;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    background-color: rgba(97, 218, 251, 0.5);
}

.projectCard:hover:before {
    transform: translateX(0);

}

.projectCard:hover .projectImage {
    transform: scale(1.1);
    -webkit-box-shadow: -6px -1px 67px 18px rgba(97, 218, 251, 0.4);
    -moz-box-shadow: -6px -1px 67px 18px rgba(97, 218, 251, 0.4);
    box-shadow: -6px -1px 67px 18px rgba(97, 218, 251, 0.4);
}

.cardTitle {
    font-size: 14px;
    margin: 0;
    font-weight: 700;
    z-index: 2;
}

.cardText {
    font-size: 16px;
    max-width: 300px;
    font-style: italic;
    margin: 10px 0 0 0;
    line-height: 23px;
    z-index: 2;
}

.cardTextBox {
    z-index: 2;
    width: 100%;
    max-width: 400px;
    margin-top: 35px;
}

.numberCardContainer {
    position: absolute;
    right: 16px;
    bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.numberCard {
    font-size: 0.7em;
    margin-bottom: 5px;
}

.projectCard:hover .verticalLine {
    height: 40px;
    transition-delay: 0.3s;
}

.verticalLine {
    transition-delay: 1s;
    width: 2px;
    height: 30px;
    background-color: #1C1D25;
    transition: 0.4s;
}

@media (max-width: 1200px) {
    .projectContainer {
        flex-wrap: wrap;
    }

    .projectCard {
        box-sizing: border-box;
        width: 50%;
        padding: 0 24px 30px;
    }
}

@media (max-width: 640px) {
    .projectCard {
        width: 100%;
    }
}
